import {useState} from 'react';
import {useLocation} from 'react-router';

const useHandleState = () => {
  const {state} = useLocation();

  const [isSortOpen, setIsSortOpen] = useState<boolean>(false);
  const [isFilterOpens, setisFilterOpens] = useState<boolean>(false);
  const [filterFields, setfilterFields] = useState<IFilters>({
    type: state?.type,
  });
  const [sortFilter, setsortFilter] = useState('lastest');
  const [search, setSearch] = useState<string>('');
  return {
    isSortOpen,
    isFilterOpens,
    filterFields,
    sortFilter,
    search,
    setIsSortOpen,
    setisFilterOpens,
    setfilterFields,
    setsortFilter,
    setSearch,
  };
};

export default useHandleState;
